<template>
    <h2 class="SubHeaderBlock primary--text"><slot></slot></h2>
</template>

<script>
  export default {
    props: {
      videoUrl: {}
    }
  }
</script>

<style lang="scss" type="text/scss">
    .SubHeaderBlock {
      margin-bottom: 16px;
      font-size: 22px;
      font-weight: 700;
    }
</style>
